/* eslint-disable no-console,no-undef, camelcase, no-constant-condition */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  fetchApi,
  getMonthName
} from "../../utils/methods";
import {  } from "../../utils/methods";
import { imageErrorMessage } from "../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  StyledLabel3,
  ButtonContainer,
  EditorContainer,
  CustomCheckBoxButton
} from "../CreateEvent/style";
import { Main } from "../AdminTeamCreation/styles";
// import Editor from "../CKEditor";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
// import CommonButton from "../common/CommonButton/CommonButton";
import { AddIconBranding, AdminCloseIcon, LaunchIcon, RecognitionCloseIcon, RecognitionBoldPencilIcon,RecognitionTickIcon, UploadHDMIcon } from "../../utils/icons";
import { AddCompanyExemplifiesValues, CreateCustomInitiativeNew, UpdateCustomInitiative, GetInitiativeDetails, GetInitiativesCategories, GetInitiativescons, GetWellbeingPillars } from "../../redux/constants/apiConstants";
import { Border } from "../Journeys/styles";
import { withRouter } from 'react-router-dom';
import { ImageUrl } from "../../utils/constants";
import { ButtonWrapper, CircleButton,  ColorGrid, EditButton,Heading, IconGrid, InitiativeIconWrapper, ModalFooter, StyledModalV1, VerticalBorder } from "../RecogntionAdmin/corevalues/styles";
import { ManagerIconContainer } from "../Manager/styles";
import parse from 'react-html-parser';
import StepsHeading from "../RecogntionAdmin/corevalues/stepNames"; 
import { AdminIconContainer} from "../RecogntionAdmin/styles";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {CommonButtonPopup} from './styles'
import {CommonButtonBorder} from '../common/commonStyles'
import {ButtonCustom} from './styles'
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import CustomColorPicker from "./CustomColorPicker";

import { t } from "i18next";


const POINTS = [
  { key: '0', Value: '0', id: '6' },
  { key: '25', Value: '25', id: '1' },
  { key: '50', Value: '50', id: '2' },
  { key: '100', Value: '100', id: '3' },
  { key: '150', Value: '150', id: '4' },
  { key: '200', Value: '200', id: '5' },
  { key: '250', Value: '250', id: '7' },
  { key: '300', Value: '300', id: '8' },
  { key: '350', Value: '350', id: '9' },
  { key: '400', Value: '400', id: '10' },
  { key: '450', Value: '450', id: '11' },
  { key: '500', Value: '500', id: '12' },
  { key: '550', Value: '550', id: '13' },
  { key: '600', Value: '600', id: '14' },
  { key: '650', Value: '650', id: '15' },
  { key: '700', Value: '700', id: '16' },
  { key: '750', Value: '750', id: '17' },
  { key: '800', Value: '800', id: '18' },
  { key: '850', Value: '850', id: '19' },
  { key: '900', Value: '900', id: '20' },
  { key: '950', Value: '950', id: '21' },
  { key: '1000', Value: '1000', id: '22' },
];





class CreateHealthInitiative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      imageName: "",
      eventPointKey: null,
      eventPointValue: null,
      colorCode: null,
      //   status: props.history?.location?.state?.status,
      recognitionId: null,
      confirmIcon: null,        
      color: "",
      so: false,
      selectedOption:"",
      step: 1,
      buttonStatus: false,
      selectedColor: null,
      icon: null,
      // iconData:[],
      selectedIcon: null,
      showModal: false,
      showColorPicker: false,
      iconColor: null,
      isSubmitting: false,
      disableButton: false,
      coreValueIcons: null,
      isModalOpen: false,
      selectedColorV1: null,
      confirmColorV1: null,
      initiativeLibraryIcons: [],
      selectedValueIcon: null,
      isPopupOpen: false,
      themeColor: null,
      initiativeImage: null,
      initiativeImageName: "",
      showCustomColorPicker: false,
      pointsArray: [
        { value: "0", text: "0", id: '6' },
        { value: "25", text: "25", id: '1' },
        { value: "50", text: "50", id: '2' },
        { value: "100", text: "100", id: '3' },
        { value: "150", text: "150", id: '4' },
        { value: "200", text: "200", id: '5' },
        { value: "250", text: "250", id: '7' },
        { value: "300", text: "300", id: '8' },
        { value: "350", text: "350", id: '9' },
        { value: "400", text: "400", id: '10' },
        { value: "450", text: "450", id: '11' },
        { value: "500", text: "500", id: '12' },
        { value: "550", text: "550", id: '13' },
        { value: "600", text: "600", id: '14' },
        { value: "650", text: "650", id: '15' },
        { value: "700", text: "700", id: '16' },
        { value: "750", text: "750", id: '17' },
        { value: "800", text: "800", id: '18' },
        { value: "850", text: "850", id: '19' },
        { value: "900", text: "900", id: '20' },
        { value: "950", text: "950", id: '21' },
        { value: "1000", text: "1000", id: '22' }
      ],            
      colors: [
        { name: "Red", colorCode: "#FCF2F3", backgroundImage: "admin-recognition/Red.png" },
        { name: "Blue", colorCode: "#F2F5FB", backgroundImage: "admin-recognition/Blue.png" },
        { name: "Maroon", colorCode: "#FEF4F2", backgroundImage: "admin-recognition/Maroon.png" },
        { name: "Green", colorCode: "#F1F8F2", backgroundImage: "admin-recognition/Green.png" },
        { name: "Orange", colorCode: "#FCF7F0", backgroundImage: "admin-recognition/Orange.png" },
        { name: "Purple", colorCode: "#FAF5F8", backgroundImage: "admin-recognition/Purple.png" },
        { name: "Yellow", colorCode: "#F5F6E8", backgroundImage: "admin-recognition/Yellow.png" },
        { name: "Teal", colorCode: "#FBF4F9", backgroundImage: "admin-recognition/Teal.png" },
      ],
      iconData: Array(50).fill({ icon: "AdminCloseIcon" }),
      initiativeCategories:[],
      selectedInitiativeCategories:[],
      selectedWellbeingPillar: null,
      wellbeingPillars:[],
      isEditMode: false,
      editData: null,
    };
  }

  togglePopup = () => {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  };


  toggleIconPopup = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  toggleColorPopup = () => {
    this.setState({ isModalOpen: false })
    this.setState((prevState) => ({ showColorPicker: !prevState.showColorPicker }));
  };

  handleModal = () => {
    this.setState({ isModalOpen: true })
  }

  handleCloseColorModal = () => {
    this.setState({ isModalOpen: false })
  }


  handleSelectedColor = () => {
    this.setState({ isModalOpen: false })
    this.setState({ selectedColorV1:this.state.confirmColorV1,themeColor: this.state.confirmColorV1?.colorCode, });
    
  }

  handleCloseModal = () => {
    this.setState({ showModal: false })
  }

  // onChangeColor = (e) => {
  //   this.setState({
  //     [e.target.name]: e.target.value,
  //   });
  // };


  onChangeColor = (e) => {
    this.setState({
      confirmColorV1: { colorCode: e.target.value }, // same format as colors array
    });
  };
  


  handleCloseColorPickerModal = () => {
    this.setState({ showColorPicker: false })
  }


  onSelectColor = (color) => {
    this.setState({ confirmColorV1: color });
    // this.setState({ confirmColorV1: color, themeColor:color?.colorCode });
  };


  // handleIconClick = (index, icon) => {
  //   this.setState({ selectedIcon: index, selectedValueIcon: icon });

  // };

  handleIconClick = (index, icon) => {
    this.setState({
      confirmIcon: icon,
      selectedIcon: index
    });
  };


  handleConfirmIcon = () => {
    this.setState({
      selectedValueIcon: this.state.confirmIcon, // set final value
      isModalOpen: false
    });
    this.handleCloseModal();
  };
  
  

  handleIconSelect = (icon) => {
    this.setState({ selectedIcon: icon, isModalOpen: false }); // Set selected icon and close modal
  };

  componentDidMount() {
    const editData = this.props.history?.location?.state?.initiativeData;
    if (editData?.id) {
      this.setState({ isEditMode: true, editData });
      this.getInitiativeDetails(editData.id);
    } else {
      this.getInitiativesIcons(null);
      this.getAllWellbeingPillars(null);
    }
    this.getInitiativesCategories();
  }

  getInitiativeDetails = async (initiativeId) => {
    try {
      const res = await fetchApi(`${GetInitiativeDetails}?id=${initiativeId}`, "GET");
      if (res.status === "success") {
        const d = res.data;
        this.setState({
          editData: d,
          title: d.initiative_name || "",
          description: d.description || "",
          themeColor: d.color || null,
          selectedColorV1: d.color ? { colorCode: d.color } : null,
          confirmColorV1: d.color ? { colorCode: d.color } : null,
          eventPointValue: d.points != null ? String(d.points) : null,
          initiativeImage: d.thumbnail ? `${ImageUrl}/${d.thumbnail}` : null,
          selectedInitiativeCategories: Array.isArray(d.categories) ? d.categories.map((c) => (typeof c === 'object' ? c.id : c)) : [],
        });
        this.getInitiativesIcons(d);
        this.getAllWellbeingPillars(d.pillar_id.id);
      } else {
        toast.error(res.error || "Failed to fetch initiative details");
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  getAllWellbeingPillars = async (pillar_id) => {
    try {
      const res = await fetchApi(GetWellbeingPillars, "GET");
      if (res.status === "success") {
        const pillars = res?.data;
        this.setState({ wellbeingPillars: pillars });
        if (pillar_id) {
          const match = pillars.find((p) => p.id === pillar_id);
          if (match) this.setState({ selectedWellbeingPillar: match });
        }
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  onChange = (e) => {
    let file = e.target.files[0];
    let fileArr = e.target.files;
    if (e.target.files[0]) {
      if (checkImage(fileArr)) {
        if (file?.size / 1000000 <= 20) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          const array = document
            .getElementById("event-upload-file")
            .value.split("\\");
          reader.onloadend = () => {
            this.setState({
              imgSrc: reader.result,
              imageName: array[array.length - 1],
            });
            getOrientation(file, (or) => {
              resetOrientation([reader.result], or, (baseImage) => {
                this.setState({
                  imgSrc: baseImage,
                });
              });
            });
          };
        } else {
          toast.error("Please select image file less than 20MB");
          document.getElementById("event-upload-file").value = "";
        }
      } else {
        toast.error(imageErrorMessage);
        document.getElementById("event-upload-file").value = "";
      }
    }
  };


  backgroundColorName = [
    {
      id: 1,
      name: 'Light Pink',
      colorCode: "#F4AAA9"

    },
    {
      id: 2,
      name: 'Pink',
      colorCode: "#DC94B5"
    },
    {
      id: 3,
      name: 'Purple',
      colorCode: "#AF87C1"
    },
    {
      id: 4,
      name: 'Blue',
      colorCode: "#6781C3"
    },
    {
      id: 5,
      name: 'Sky Blue',
      colorCode: "#85C0EA"
    },
    {
      id: 6,
      name: 'Peacock Blue',
      colorCode: "#007AB1"
    },
    {
      id: 7,
      name: 'Dark Green',
      colorCode: "#006F88"
    },
    {
      id: 8,
      name: 'Green',
      colorCode: "#76AB78"
    },
    {
      id: 9,
      name: 'Yellow',
      colorCode: "#F1C977"
    },
    {
      id: 10,
      name: 'Orange',
      colorCode: "#FFBF73"
    },
  ];

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };

  onSelectPoints = (name) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventPointValue: name.value,
    });
  };


  onSelectColors = (name) => {
    this.setState({
      selectedColor: name
    });
  };

  submitInitiative = async () => {
    const { isEditMode, editData, title, eventPointValue, description, selectedValueIcon, themeColor, initiativeImage, selectedInitiativeCategories, selectedWellbeingPillar } = this.state;

    const thumbnailForPayload = initiativeImage && initiativeImage.startsWith('data:image')
      ? initiativeImage
      : editData?.thumbnail || initiativeImage;
    const companyId = this.props.companyInfo?.id;

    if (isEditMode) {
      const payload = {
        company_id: editData.company_id,
        initiative_id: editData?.id,
        initiative_name: title,
        description,
        initiative_image: selectedValueIcon?.initiative_icon_orange_image,
        initiative_white_icon: selectedValueIcon?.initiative_icon_white_image,
        color: themeColor,
        points: parseInt(eventPointValue),
        thumbnail: thumbnailForPayload,
        pillar_id: selectedWellbeingPillar?.id || null,
        categories: selectedInitiativeCategories,
      };
      try {
        const response = await fetchApi(UpdateCustomInitiative, 'PUT', payload);
        if (response.status === 'success') {
          toast.success(response.data?.message || response.data?.[0] || "Initiative updated successfully");
          this.props.history.goBack();
        } else {
          toast.error(response?.data?.message);
        }
      } catch (error) {
        window.console.error(error);
      }
      return;
    }

    
    const payload = {
      company_id: this.props.role === "ADMIN" ? 0 : companyId,
      initiative_name: title,
      description: description,
      initiative_image: selectedValueIcon?.initiative_icon_orange_image,
      initiative_white_icon: selectedValueIcon?.initiative_icon_white_image,
      color: themeColor,
      points: eventPointValue,
      thumbnail: initiativeImage,
      categories: selectedInitiativeCategories,
      pillar_id: this.props.role === "ADMIN" ? selectedWellbeingPillar?.id || null : null
    };
    try {
      const response = await fetchApi(CreateCustomInitiativeNew, 'POST', payload);
      if (response.status === 'success') {
        toast.success(response.data?.message || response.data?.[0] || "Initiative created successfully");
        this.props.history.push({ pathname: "/company/health", state: "library" });
      } else {
        toast.error(response?.data?.message);
        this.setState({ isSubmitting: false });
      }
    } catch (error) {
      window.console.error(error);
      this.setState({ isSubmitting: false });
    }
  };



  saveData = () => {
    const {
      title,
      description,
      eventPointValue,
      recognitionId,
      //   status
    } = this.state;
    const { companyInfo } = this.props;
    const RecognitionDetails = {
      company_id: companyInfo?.id,
      is_deleted: [],
      recognitions: [
        {
          core_value: title,
          description: description,
          id: recognitionId,
          point: eventPointValue,
          //   status: status
        }
      ]
    };

    this.PostRecognition(RecognitionDetails);
  };

  PostRecognition = async (payload) => {
    try {
      const res = await fetchApi(AddCompanyExemplifiesValues, "POST", payload);
      if (res?.data?.message) {
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
        });
      } else {
        toast.success(res.data[0]);
        this.props.history.push(`/company/recognition/addcorevalues`);
      }
    } catch (error) {
      toast.error(error)
    }
  }

  getInitiativesIcons = async (editData) => {
    try {
      const res = await fetchApi(GetInitiativescons, "GET");
      if (res.status === "success") {
        const icons = res.data;
        this.setState({ initiativeLibraryIcons: icons });
        if (editData?.initiative_image) {
          const matchIndex = icons.findIndex(
            (icon) => icon.initiative_icon_orange_image === editData.initiative_image
          );
          if (matchIndex !== -1) {
            this.setState({
              selectedIcon: matchIndex,
              selectedValueIcon: icons[matchIndex],
              confirmIcon: icons[matchIndex],
            });
          }
        }
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  getInitiativesCategories = async () => {
    let apiUrl = GetInitiativesCategories;
    try {
      const res = await fetchApi(apiUrl + "?type=list", "GET");
      if (res.status === "success") {
        this.setState({ initiativeCategories: res.data })
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  handleOptionChange = (value) => {
    this.setState({selectedOption:value});
  };

  onInitiativeImageChange = (imgSrc, imageName) => {
    this.setState({ initiativeImage: imgSrc, initiativeImageName: imageName });
  };

  onInitiativeImageRemove = () => {
    this.setState({ initiativeImage: null, initiativeImageName: "" });
  };
  handleCustomColorDone = (hex) => {
    this.setState({
      confirmColorV1: { colorCode: hex },
      selectedColorV1: { colorCode: hex },
      themeColor: hex,
      showCustomColorPicker: false,
      isModalOpen: false,
    });
  };




  // onChangeDescription = (evt) => {
  //   const newContent = evt.getData();
  //   const tempDiv = document.createElement("div");
  //   tempDiv.innerHTML = newContent;
  //   const plainText = tempDiv.textContent || tempDiv.innerText || "";
  
  //   if (plainText.length > 300) {
  //     this.setState({ disableButton: true });
  //     return;
  //   }
  
  //   this.setState({ description: newContent, disableButton: false });
  // };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  nextStep = (value) => {
    this.setState({
      step: value,
      buttonClickScrollTop: true,
      buttonStatus: false,
    });
  };

  redirect = () => {
    if (this.state.isEditMode) {
      this.props.history.goBack();
    } else {
      this.props.history.push({ pathname: "/company/health", state: "library" });
    }
  };

  renderHeading = () => (
    <Heading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
      </div>
      {this.state.isEditMode ? this.props.t("Edit Health Initiative") : this.props.t("Create Health Initiative")}
    </Heading>
  );

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };


  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };


  toggleColorPickerModal = () => {
    this.setState((prevState) => ({ showColorPicker: !prevState.showColorPicker }));
  };

  getLastSegmentAfterUnderscore(input) {
    // Get the filename
    const filename = input.split('/').pop(); // orange_social_wellness.png
  
    // Remove file extension
    const nameWithoutExtension = filename.replace(/\.[^/.]+$/, ""); // orange_social_wellness
  
    // Get part after last underscore
    const parts = nameWithoutExtension.split('_');
    if (parts.length < 2) return ""; // not enough underscores to extract
  
    // Join last parts (after the first word)
    const result = parts.slice(1).join(' '); // social wellness
    return result;
  }

  getVividBorderColor(hex) {
    const num = parseInt(hex.replace('#', ''), 16);
    const r = (num >> 16) & 0xff;
    const g = (num >> 8) & 0xff;
    const b = num & 0xff;
    const avg = (r + g + b) / 3;
    return `rgb(
      ${Math.min(255, Math.round(r + (r - avg) * 7))},
      ${Math.min(255, Math.round(g + (g - avg) * 7))},
      ${Math.min(255, Math.round(b + (b - avg) * 7))}
    )`;
  }



  stepOneForm = () => {
    const {
      title,
      description,
      step,
      showModal,
      initiativeLibraryIcons,
      selectedValueIcon,
      themeColor,
      initiativeImage,
    } = this.state;
    const { t } = this.props;
    return (
      <Layout>
        <div className="main" >
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="create-hdm-initiative" padding="20px 20px 265px 20px" />
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the health initiative")}<span style={{ color: "#DA6C74" }}>*</span></StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter text")}
                    name="title"
                    value={title}
                    maxLength="25"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61 !important"
                    onChange={this.onChangeInput}
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                  <div className="count">{title?.length}/25 | C</div>
                </InputContainer>

                <Border style={{ background: 'rgba(0, 92, 135, 0.10)', margin: '20px 0px' }} />
                <div style={{ display: "flex", width: "50%" ,gap: "40px"}}>
                  <div style={{paddingRight:'40px', borderRight:'1px solid #efefef'}}>
                    <InputContainer>
                      <StyledLabel isFont={"14px"} color={"#184A61"} margin="0" marginb='0'>
                        {t("Initiative Image")} <span style={{ color: "#BDBDBD", fontFamily:'lato',fontSize:'12px',marginLeft:'4px' }}>(Size limit up to 2 MB)</span> <span style={{ color: "#DA6C74" }}>*</span>
                      </StyledLabel>
                      <CommonImageUploader
                        imgSrc={initiativeImage}
                        onImageChange={this.onInitiativeImageChange}
                        onRemoveImage={this.onInitiativeImageRemove}
                        ImageType={"(.jpeg, .png, .jpg)"}
                        accept=".jpeg, .png, .jpg"
                        t={this.props.t}
                        margin='0'
                        maxSizeMB='2'
                      />
                    </InputContainer> 
                  </div>
                  <InputContainer style={{ minWidth: "28%", alignItems:'center'}}>
                    <StyledLabel3 isFont={"14px"} color={"#184A61"} margin={"-40px"}>{this.props.t("Initiative icon")}<span style={{ color: "#DA6C74" }}>*</span></StyledLabel3>
                    <StyledLabel3 isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Select icon")}</StyledLabel3>
                    <ButtonWrapper isMargin={"7.5px"}>
                      {/* <CircleButton color={selectedValueIcon? themeColor: null} onClick={this.toggleIconPopup}>
                        {selectedValueIcon ? (
                          <div
                            style={{
                              position: 'absolute',
                              left: '28px',
                              top: '55%',
                              transform: 'translateY(-50%)',
                              width: '36px',
                              height: '36px',
                              pointerEvents: 'none',
                            }}> {themeColor? <img src={ImageUrl + "/" + selectedValueIcon?.initiative_icon_white_image} width={"24px"} height={"auto"} />:<img src={ImageUrl + "/" + selectedValueIcon?.initiative_icon_orange_image} width={"24px"} height={"auto"} />}</div>
                        ) : AddIconBranding(16, 16)}
                      </CircleButton> */}
                      <CircleButton color={selectedValueIcon ? themeColor : null} onClick={this.toggleIconPopup}>
                        {selectedValueIcon ? (
                          <div
                            style={{
                              position: 'absolute',
                              left: '28px',
                              top: '55%',
                              transform: 'translateY(-50%)',
                              width: '36px',
                              height: '36px',
                              pointerEvents: 'none',
                            }}>
                            {themeColor 
                              ? <img src={ImageUrl + "/" + selectedValueIcon?.initiative_icon_white_image} width={"24px"} height={"auto"} /> 
                              : <img src={ImageUrl + "/" + selectedValueIcon?.initiative_icon_orange_image} width={"24px"} height={"auto"} />}
                          </div>
                        ) : AddIconBranding(16, 16)}
                      </CircleButton>

                      {!this.state.selectedValueIcon?null: (
                        <EditButton onClick={this.toggleIconPopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )}
                    </ButtonWrapper>
                  </InputContainer>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                  }}>
                    <VerticalBorder />
                  </div>
                  <InputContainer width="auto" style={{ minWidth: "125px",textAlign:'center' }}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Background color")}<span style={{ color: "#DA6C74" }}>*</span></StyledLabel>
                    <ButtonWrapper isMargin={"14.5px"}>
                      {/* <CircleButton color={themeColor} onClick={this.togglePopup}>
                        <div>{themeColor? null:AddIconBranding(16, 16)}</div>
                      </CircleButton>
                      {themeColor && (
                        <EditButton onClick={this.togglePopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )} */}
                      <CircleButton color={this.state.selectedColorV1?.colorCode} onClick={this.togglePopup}>
                        <div>{this.state.selectedColorV1 ? null : AddIconBranding(16, 16)}</div>
                      </CircleButton>
                      {this.state.selectedColorV1 && (
                        <EditButton onClick={this.togglePopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )}
                    </ButtonWrapper>
                  </InputContainer>
                  
                  
                </div>
                <Border style={{ background: 'rgba(0, 92, 135, 0.10)', margin: '20px 0px' }} />

                <StyledModalV1 show={this.state.isModalOpen} onHide={this.handleCloseColorModal} width="800px" height="240px">
                  <div className="modal-content-padding">
                    <div className="header-wrapper">
                      <div className="heading">{t("Choose Background Color For Icon")}</div>
                      <div className="close-icon" onClick={this.handleCloseColorModal}>
                        {AdminCloseIcon()}
                      </div>
                    </div>
                    <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                    <ColorGrid>
                      {this.state.colors.map((color) => (
                        <div
                          key={color.colorCode}
                          onClick={() => this.onSelectColor(color)}
                          style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '8px',
                            background: color.colorCode,
                            border: this.state.confirmColorV1?.colorCode === color.colorCode
                              ? `0.75px solid ${this.getVividBorderColor(color.colorCode)}`
                              : `0.75px solid ${this.getVividBorderColor(color.colorCode)}`,
                            cursor: 'pointer',
                            boxSizing: 'border-box',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {this.state.confirmColorV1?.colorCode === color.colorCode && <span className="tickIcon">{RecognitionTickIcon()}</span>}
                        </div>
                      ))}



                    </ColorGrid>
                    <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                    <ModalFooter isHeightButton="40px">
                      <ButtonCustom
                        isButtoHeight=""
                        isBg={true}
                        padding="12px"
                        onClick={() => this.setState({ showCustomColorPicker: true })}
                      >
                        <AdminIconContainer isWidth={"16px"} isHeight={"16px"}>
                          {UploadHDMIcon()}
                        </AdminIconContainer>{" "}
                        Choose custom color
                      </ButtonCustom>


                      {/* <CommonButtonPopup 
                        background={themeColor?"#DA6C74":"#EFEFEF"}
                        color={themeColor?"#FEFEFE":"#989898"}
                        onClick={themeColor? this.handleSelectedColor:null}>
                        {("Select Color")}{RecognitionTickIcon(themeColor?'white':"#989898")}
                      </CommonButtonPopup> */}
                      <CommonButtonPopup 
                        background={this.state.confirmColorV1 ? "#DA6C74" : "#EFEFEF"} 
                        color={this.state.confirmColorV1 ? "#FEFEFE" : "#989898"} 
                        onClick={this.state.confirmColorV1 ? this.handleSelectedColor : null}
                      >
                        Select Color
                        {RecognitionTickIcon(this.state.confirmColorV1 ? "white" : "#989898")}
                      </CommonButtonPopup>
                    </ModalFooter>
                  </div>
                </StyledModalV1>
                {this.state.showCustomColorPicker && (
                  <CustomColorPicker
                    onDone={this.handleCustomColorDone}
                    onClose={() => this.setState({ showCustomColorPicker: false })}
                  />
                )}

                {showModal && (
                  <StyledModalV1 isPadding={"0px 16px"} show={showModal} onHide={this.handleCloseModal} width="600px" height="424px">
                    <div className="modal-content-padding">
                      <div className="header-wrapper">
                        <div className="heading">{t("Choose Health Initiative Icon")}</div>
                        <div className="close-icon" onClick={this.handleCloseModal}>
                          {AdminCloseIcon()}
                        </div>
                      </div>
                      <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                      <IconGrid>
                        {initiativeLibraryIcons?.length > 0 ? (
                          this.state.initiativeLibraryIcons?.map((icon, index) => (
                            <InitiativeIconWrapper
                              key={index}
                              isSelected={this.state.selectedIcon === index}
                              onClick={() => this.handleIconClick(index, icon)}>
                              <img src={this.state.selectedIcon === index ? ImageUrl + "/" + icon?.initiative_icon_white_image : ImageUrl + "/" + icon?.initiative_icon_orange_image} />
                              <span className="tooltip-text">{this.getLastSegmentAfterUnderscore(icon?.initiative_icon_orange_image)  || "Icon"}</span>
                            </InitiativeIconWrapper>
                          ))
                        ) : (
                          <p>No icons available</p>
                        )}
                      </IconGrid>
                      <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                      <ModalFooter>
                        {/* <CommonButtonPopup background={selectedValueIcon?"#DA6C74":"#EFEFEF"} color={selectedValueIcon?"#FEFEFE":"#989898"} 
                        onClick={selectedValueIcon? this.handleCloseModal:null}>
                          {("Select Icon")}{RecognitionTickIcon(selectedValueIcon?'white':"#989898")}
                        </CommonButtonPopup> */}

                        <CommonButtonPopup 
                          background={this.state.confirmIcon ? "#DA6C74" : "#EFEFEF"} 
                          color={this.state.confirmIcon ? "#FEFEFE" : "#989898"} 
                          onClick={this.state.confirmIcon ? this.handleConfirmIcon : null}
                        >
                          Select Icon
                          {RecognitionTickIcon(this.state.confirmIcon ? 'white' : "#989898")}
                        </CommonButtonPopup>
                      </ModalFooter>
                    </div>
                  </StyledModalV1>
                )}
                {/* <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px'}}/> */}
                <InputContainer isColorError={parse(description)?.[0]?.props?.children?.[0]?.length > 300}>
                  <StyledLabel isFont={"14px"} style={{ marginTop: "0px" }} color={"#184A61"}>{this.props.t("About the health initiative")}<span style={{ color: "#DA6C74" }}>*</span></StyledLabel>
                  <EditorContainer>
                    <CKEditor
                      config={{
                        placeholder: "Write description here..."}}
                      editor={ClassicEditor}
                      data={this.state.description}
                      onReady={(editor) => {
                        this.editorInstance = editor;

                        editor.model.document.on('change:data', () => {
                          const plainText = editor.getData()
                            .replace(/<[^>]*>/g, '')
                            .replace(/&nbsp;/g, ' ')
                            .trim();

                          if (plainText.length > 300) {
                            const truncated = plainText.substring(0, 300);
                            editor.setData(truncated);
                          }

                          this.setState({
                            description: editor.getData(),
                            disableButton: plainText.length > 300,
                          });
                        });
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.setState({ description: data });
                      }}
                    />
                  </EditorContainer>
                  <div className="char-count">{parse(description)?.[0]?.props?.children?.[0]?.length || 0}/300 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  onSelectClass = (name, value) => {
    const selectedValues = [...this.state[name]];
  
    if (selectedValues.includes(value)) {
      const index = selectedValues.findIndex((item) => item === value);
      if (index > -1) selectedValues.splice(index, 1);
    } else {
      if (selectedValues.length < 6) {
        selectedValues.push(value);
      }
    }
  
    this.setState({
      [name]: selectedValues,
    });
  };

  onSelectTheme = (item) => {
    this.setState({selectedWellbeingPillar:item});
  };

  stepTwoForm = () => {
    const {
      step,
      eventPointValue,
      // pointsArray,
      initiativeCategories,
      selectedInitiativeCategories,
      selectedWellbeingPillar,
      wellbeingPillars,
      so
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container isHeight="104px" color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="create-hdm-initiative" padding="20px 20px 265px 20px" />
            </div>
            <div className="form">
              <div className="formBody">
                <CommonDropdown
                  tileContainerStyle={{ width: '100%', padding: '0px', margin:'0 0 10px 0' }}
                  dropdownStyle={{ top: '90px' }}
                  labelText="Health Initiative points"
                  isRequired
                  dropdownOpen={so}
                  placeholder="Select Point value"
                  title={eventPointValue ? `${eventPointValue} Points` : ""}
                  id="dropdown-points"
                  onClick={() => this.setState({ so: !so })}
                  data={POINTS}
                  onSelect={(list) => this.setState({ eventPointValue: list.key, so: false })}
                  active={eventPointValue}
                  onSelectParameter={['eventPointValue', 'Value', 'key']}
                  valueString={"Points"}
                  itemValue
                  valueIndex={1}
                  labelMargin="0px"
                  dropIcon
                />


                <div style={{display:"flex", border:"1px solid #EFEFEF", margin:"20px 0"}}></div>

                <InputContainer isFlex={"0 0 220px"}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb="12px">
                    {this.props.t("Category")}
                    {<div className="subDescription">(min 1 & max 6)</div>}
                    {<span>*</span>}
                  </StyledLabel>
                  <div className="radioButtonClassCategoriesV1" style={{gap:'12px 7%'}}>
                    {
                      initiativeCategories.map((category, index)=>(
                        <div className="labelName" key={category.id}>
                          <CustomCheckBoxButton
                            isSelected={selectedInitiativeCategories.includes(initiativeCategories[index].id)}
                            onClick={() => {
                              this.onSelectClass(
                                "selectedInitiativeCategories",
                                initiativeCategories[index].id
                              );
                              this.setState({
                                selectedOndemandCategory: initiativeCategories[index].name
                              });
                            }}
                            background={"#85c0ea"}
                          >
                            {selectedInitiativeCategories.includes(initiativeCategories[index].id) &&  <div>{RecognitionTickIcon()}</div>}
                          </CustomCheckBoxButton>
                          <div className="category-name">{category?.category_name}</div>
                        </div>
                      ))
                    }
                  </div>
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '8px 0px',display:"flex" }} />
                {this.props.role === "ADMIN"?<CommonDropdown
                  tileContainerStyle={{ width: "100%", padding: "0px 0px 12px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={t("Select monthly theme")} 
                  dropdownOpen={so}
                  placeholder={ wellbeingPillars?.length > 0 ? t("Select monthly theme (optional)") : t("No Themes Available")}
                  title={(selectedWellbeingPillar?.pillar_title) ? ` ${getMonthName(selectedWellbeingPillar?.id) + " - " + selectedWellbeingPillar?.pillar_title}` : t('Select theme')}
                  id="dropdown-monthly-theme"
                  onClick={() => this.setState({ so: !so })}
                  data={wellbeingPillars}
                  onSelect={this.onSelectTheme}
                  onSelectParameter={['pillar_title','id']}
                  itemValue={true}
                  valueIndex={0}
                  dropIcon={true}
                  labelMargin={"0px"}
                  fontSize={"16px"}
                  showMonthName={true}
                  isRequired
                />:null}
                {/* <CommonDropdown
                  tileContainerStyle={{ width: "100%", padding: "0px 0px 20px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Health Initiative point ")}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select Point Value")}
                  title={
                    eventPointValue ? eventPointValue: +"No Points"
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={pointsArray}
                  onSelect={this.onSelectPoints}
                  active={eventPointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  dropIcon={true}
                /> */}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  render() {
    const {
      step,
      title,
      description,
      selectedValueIcon,
      eventPointValue,
      themeColor,
      initiativeImage,
      selectedInitiativeCategories,
      selectedWellbeingPillar
    } = this.state;
    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2
            ? this.stepTwoForm()
            : null}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title || !description || !selectedValueIcon || !themeColor || !initiativeImage} onClick={!title || !description || !selectedValueIcon || !themeColor||!initiativeImage ?null: () => this.updateStep(2)}>
                Next
                {!title || !description || !selectedValueIcon || !themeColor}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) :
          step === 2 && (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px" onClick={() => this.nextStep(1)} margin="auto auto auto 0px">
                 
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup margin="auto 0 auto auto" width="180px" height="48px" disabled={!selectedInitiativeCategories.length || (this.props.role === "ADMIN" && !selectedWellbeingPillar?.id) || !eventPointValue } onClick={!selectedInitiativeCategories.length || (this.props.role === "ADMIN" && !selectedWellbeingPillar?.id) || !eventPointValue  ?null: () => this.submitInitiative()}>
                  {this.state.isEditMode ? "Update Initiative" : "Create Initiative"}{!selectedInitiativeCategories.length || (this.props.role === "ADMIN" && !selectedWellbeingPillar?.id) || !eventPointValue ? LaunchIcon("#989898"):LaunchIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          )}
      </React.Fragment>
    );
  }
}

CreateHealthInitiative.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  t: PropTypes.func,
  companyInfo: PropTypes.object
};

export default (withRouter(withTranslation()(CreateHealthInitiative)));